var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#F1F5FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 23.4142C15.4477 23.4142 15 23.8619 15 24.4142C15 24.9665 15.4477 25.4142 16 25.4142L22.5001 25.4142C22.7762 25.4142 23.0001 25.6381 23.0001 25.9142L23.0001 32.4143C23.0001 32.9666 23.4478 33.4143 24.0001 33.4143C24.5523 33.4143 25.0001 32.9666 25.0001 32.4143L25.0001 25.9142C25.0001 25.6381 25.2239 25.4142 25.5001 25.4142L32 25.4142C32.5523 25.4142 33 24.9665 33 24.4142C33 23.8619 32.5523 23.4142 32 23.4142L25.5001 23.4142C25.2239 23.4142 25.0001 23.1904 25.0001 22.9142L25.0001 16.4143C25.0001 15.862 24.5523 15.4143 24.0001 15.4143C23.4478 15.4143 23.0001 15.862 23.0001 16.4143L23.0001 22.9142C23.0001 23.1904 22.7762 23.4142 22.5001 23.4142L16 23.4142Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCard);
export default __webpack_public_path__ + "static/media/add_card.a797ed3901ec99085006a07606706523.svg";
export { ForwardRef as ReactComponent };